"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
class AWSSecurityConfiguration {
    constructor() {
        this.getAccessKey = () => tslib_1.__awaiter(this, void 0, void 0, function* () { return ''; });
        this.getSecretKey = () => tslib_1.__awaiter(this, void 0, void 0, function* () { return ''; });
        this.getSessionToken = () => tslib_1.__awaiter(this, void 0, void 0, function* () { return ''; });
    }
    static getInstance() {
        if (!AWSSecurityConfiguration.instance) {
            AWSSecurityConfiguration.instance = new AWSSecurityConfiguration();
        }
        return AWSSecurityConfiguration.instance;
    }
    getCredentialGetters() {
        return {
            getAccessKey: this.getAccessKey,
            getSecretKey: this.getSecretKey,
            getSessionToken: this.getSessionToken
        };
    }
    initialiseCredentialGetters(credentialGetters) {
        this.getAccessKey = credentialGetters.getAccessKey;
        this.getSecretKey = credentialGetters.getSecretKey;
        this.getSessionToken = credentialGetters.getSessionToken;
    }
}
exports.awsSecurityConfiguration = AWSSecurityConfiguration.getInstance();
//# sourceMappingURL=awsSecurityConfiguration.js.map